import { buildStepNarration } from './stepNarrationCopy.js'

export const DESIGN_DNA_SHOWCASE_AI_LOG_STEPS = [
  {
    durationMs: 2400,
    actionName: 'Loaded skill',
    arguments: { skill: 'fullstack-dev', action: 'Initialize fullstack development environment' },
    result: { ok: true },
    status: 'ok',
    stepNarration: buildStepNarration(
      'Fullstack dev environment initialized — checking package.json and project structure',
      'installing MUI packages',
      0,
    ),
  },
  {
    durationMs: 3600,
    actionName: 'Ran command',
    arguments: {
      command: 'npm install @mui/material @mui/icons-material @mui/x-data-grid @mui/x-charts @mui/x-date-pickers @mui/x-tree-view @mui/lab',
    },
    result: { ok: true },
    status: 'ok',
    stepNarration: buildStepNarration(
      'MUI core, icons, and MUI X packages installed',
      'reading layout.tsx and globals.css',
      1,
    ),
  },
  {
    durationMs: 4200,
    actionName: 'Read file',
    arguments: { path: '/home/z/my-project/src/app/layout.tsx' },
    result: { ok: true },
    status: 'ok',
    stepNarration: buildStepNarration(
      'Existing Next.js app structure mapped',
      'creating mui-theme.ts',
      2,
    ),
  },
  {
    durationMs: 5200,
    actionName: 'Wrote file',
    arguments: { op: 'write', path: '/home/z/my-project/src/lib/mui-theme.ts' },
    result: { ok: true },
    status: 'ok',
    stepNarration: buildStepNarration(
      'Premium white theme with Design DNA tokens written',
      'building MuiShowcase.tsx',
      3,
    ),
  },
  {
    durationMs: 12400,
    actionName: 'Wrote file',
    arguments: { op: 'write', path: '/home/z/my-project/src/components/MuiShowcase.tsx', lines: 2612 },
    result: { ok: true },
    status: 'ok',
    stepNarration: buildStepNarration(
      'Full component showcase created — 60+ components across 8 categories',
      'updating layout.tsx and page.tsx',
      4,
    ),
  },
  {
    durationMs: 3800,
    actionName: 'Edited file',
    arguments: { path: '/home/z/my-project/src/components/MuiShowcase.tsx', fix: 'Grid2 → Grid (MUI v9)' },
    result: { ok: true },
    status: 'ok',
    stepNarration: buildStepNarration(
      'Grid import fixed for MUI v9 — DOM prop warnings resolved',
      'running ESLint',
      5,
    ),
  },
  {
    durationMs: 2800,
    actionName: 'Ran command',
    arguments: { command: 'npm run lint' },
    result: { ok: true, issues: 0 },
    status: 'ok',
    stepNarration: buildStepNarration(
      'ESLint passes clean',
      'verifying with agent-browser',
      6,
    ),
  },
  {
    durationMs: 6400,
    actionName: 'Loaded skill',
    arguments: { skill: 'agent-browser', url: 'http://localhost:3000' },
    result: { status: 200, sections: ['Charts', 'TreeView', 'Timeline', 'TextField'] },
    status: 'ok',
    stepNarration: buildStepNarration(
      'Browser agent verified sidebar navigation and all MUI X sections',
      'writing worklog',
      7,
    ),
  },
  {
    durationMs: 3200,
    actionName: 'Wrote file',
    arguments: { op: 'write', path: '/home/z/my-project/worklog.md' },
    result: { ok: true },
    status: 'ok',
    stepNarration: buildStepNarration(
      'Build worklog written — showcase live at localhost:3000',
      'handoff complete',
      8,
    ),
  },
]
